import { render, staticRenderFns } from "./FormControlAccountSettingsSecondaryDomains.vue?vue&type=template&id=2b1a11f2&scoped=true"
import script from "./FormControlAccountSettingsSecondaryDomains.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlAccountSettingsSecondaryDomains.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlAccountSettingsSecondaryDomains.vue?vue&type=style&index=0&id=2b1a11f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a11f2",
  null
  
)

export default component.exports